import { connect } from 'react-redux';
import MCompletedOrderPage from './MCompleteOrderPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getMCompleteOrderData } from 'src/actions/manufacturAction';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';

export const mapStateToProps = (state: AppState) => {
    return {
        mCompletedOrderData: state.manufactur.mCompleteOrderData,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
        orderDataTat: state.fileUpload.orderDataTat
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getMCompleteOrderData);
        },
        reload: () => {
            dispatch(getMCompleteOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'mcompleted'));
        },
        dateFilter: () => {
            dispatch(getMCompleteOrderData);
        },
        dateReset: () => {
            dispatch(getMCompleteOrderData);
        },
        caseFilter: (fcaseno: string, tcaseno: string, status: string) => {
            // dispatch(getMInproductionOrderDataFilter(fcaseno, tcaseno, status));
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        }
    };
};

const MCompleteOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MCompletedOrderPage);

export default MCompleteOrderContainer;



// WEBPACK FOOTER //
// ./src/components/MCompleteOrder/MCompleteContainer.tsx